import { differenceInYears } from "date-fns";

export const isOlderThanYears = (
  dateString: string,
  years: number,
): boolean => {
  return differenceInYears(new Date(), new Date(dateString)) >= years;
};
